<template>
  <div class="configureNetwork">
    <h1>{{ $t("configureNetwork") }}</h1>
    <div class="edit-section">
      <el-button class="blue-btn" style="float: right" @click="saveInfo">{{
        $t("save")
      }}</el-button>
    </div>
    <div class="desc-content">
      <div class="info-item-warp">
        <div class="info-item">
          <div class="info-item-label">{{ $t("networkingInformation") }}</div>
          <div class="info-item-content">
            <div class="left">{{ $t("localAddr") }}</div>
            <div class="right">
              <el-input
                style="width: 217px;"
                :placeholder="$t('pleaseInput')"
                v-model.number="netWorkInfo.LocalAddr"
                onkeyup="value=value.replace(/^\.+|[^\d.]/g,'')"
                @input="localInput"
                :maxlength="2"
                :minlength="1"
              />
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("networkMode") }}</div>
            <div class="right">
              <el-select v-model="netWorkInfo.NetworkMode">
                <el-option :label="$t('projectPanelTypeSingle')" :value="0">
                </el-option>
                <el-option :label="$t('projectPanelTypeNetwork')" :value="1">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("networkClass") }}</div>
            <div class="right">
              <el-select v-model="netWorkInfo.NetworkClass">
                <el-option :label="$t('classB')" :value="0"> </el-option>
                <el-option :label="$t('classA')" :value="1"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("dataTransferDevice") }}</div>
            <div class="right">
              <el-select v-model="netWorkInfo.DataTransferDevice">
                <el-option :label="$t('off')" :value="0"> </el-option>
                <el-option :label="$t('on')" :value="1"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("rs485") }}</div>
            <div class="right">
              <el-select v-model="netWorkInfo.RS485">
                <el-option :label="$t('off')" :value="0"> </el-option>
                <el-option :label="$t('on')" :value="1"> </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="info-item">
          <div class="info-item-label">{{ $t("sendFilter") }}</div>
          <div class="info-item-content" v-for="item in filterArr">
            <div class="left">{{ $t(`${item.key}`) }}</div>
            <div class="right">
              <el-select v-model="item.value">
                <el-option :label="$t('doNostSend')" :value="0"> </el-option>
                <el-option :label="$t('send')" :value="1"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="info-item-warp-right">
        <div class="info-items" v-for="(item, index) in netWorkInfo.netMap">
          <div class="info-item">
            <div class="info-item-label">{{ $t("sendNetMap") }}</div>
            <div class="info-item-content-warp">
              <div class="info-item-content">
                <div class="left">{{ $t("startAddr") }}</div>
                <div class="right">
                  <el-input
                    :placeholder="$t('pleaseInput')"
                    v-model.number="item.netMapStartAdd"
                    onkeyup="value=value.replace(/^\.+|[^\d.]/g,'')"
                    @blur="checknum('min')"
                    @input="localInput"
                    :maxlength="2"
                    :minlength="1"
                  />
                </div>
              </div>
              <div class="info-item-content">
                <div class="left">{{ $t("endAddr") }}</div>
                <div class="right">
                  <el-input
                    :placeholder="$t('pleaseInput')"
                    v-model.number="item.netMapEndAdd"
                    onkeyup="value=value.replace(/^\.+|[^\d.]/g,'')"
                    @blur="checknum('max')"
                    @input="localInput"
                    :maxlength="2"
                    :minlength="1"
                  />
                </div>
              </div>
              <div class="info-item-content">
                <div class="left">{{ $t("register") }}</div>
                <div class="right">
                  <el-select v-model="item.netMapRegister">
                    <el-option :label="$t('off')" :value="0"> </el-option>
                    <el-option :label="$t('on')" :value="1"> </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-item-label">{{ $t("acceptanceFiltering") }}</div>
            <div class="info-item-content-warp flag">
              <div
                class="info-item-content"
                v-for="item in MapAcceptanceArr[index]"
              >
                <div class="left">{{ $t(`${item.key}`) }}</div>
                <div class="right">
                  <el-select v-model="item.value">
                    <el-option :label="$t('noReception')" :value="0">
                    </el-option>
                    <el-option :label="$t('reception')" :value="1"> </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="del">
            <i
              class="el-icon-remove-outline"
              v-if="netWorkInfo.netMap.length != 1"
              @click="delNetMap(index)"
            ></i>
          </div>
        </div>
        <i class="el-icon-circle-plus-outline add" @click="addNetMap"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { getPanelDetail, setPanelNetworkInfo } from "../../api/panel";
export default {
  name: "configureNetwork",
  data() {
    return {
      panelId: this.$route.query.panelId,
      panelNo: this.$route.query.panelNo,
      projectId: this.$route.query.projectId,
      netWorkInfo: {
        LocalAddr: 0,
        NetworkMode: 1,
        NetworkClass: 1,
        DataTransferDevice: 1,
        RS485: 0,
        SendFilter: 29,
        netMap: [
          {
            netMapStartAdd: 0,
            netMapEndAdd: 0,
            netMapRegister: 1,
            netMapAcceptanceFilter: 29
          }
        ]
      },
      filterArr: [
        {
          value: 0,
          key: "Alarm"
        },
        {
          value: 0,
          key: "Fault"
        },
        {
          value: 0,
          key: "Disable"
        },
        {
          value: 0,
          key: "Reset"
        },
        {
          value: 0,
          key: "Silence"
        },
        {
          value: 0,
          key: "Time"
        },
        {
          value: 0,
          key: "Delay"
        }
      ],
      MapAcceptanceArr: [
        [
          {
            value: 0,
            key: "Alarm"
          },
          {
            value: 0,
            key: "Fault"
          },
          {
            value: 0,
            key: "Disable"
          },
          {
            value: 0,
            key: "Reset"
          },
          {
            value: 0,
            key: "Silence"
          },
          {
            value: 0,
            key: "Time"
          },
          {
            value: 0,
            key: "Delay"
          }
        ]

        // receptionArr
      ]
    };
  },
  methods: {
    localInput(value) {
      if (typeof value !== "number") {
        return;
      }
      if (value > 100) this.netWorkInfo.LocalAddr = 99;
      if (value < 0 || value == "" || value == null)
        this.netWorkInfo.LocalAddr = 0;
    },
    saveInfo() {
      if (
        this.netWorkInfo.netMap[this.netWorkInfo.netMap.length - 1]
          .netMapStartAdd == null ||
        !this.netWorkInfo.netMap[this.netWorkInfo.netMap.length - 1]
          .netMapEndAdd == null
      ) {
        this.$message.info(this.$t("notDataFill"));
        return;
      }
      this.netWorkInfo.SendFilter = this.toDecimal(this.filterArr);
      let i = this.netWorkInfo.netMap;
      for (let d = 0; d < i.length; d++) {
        i.netMapAcceptanceFilter = this.toDecimal(this.MapAcceptanceArr[d]);
        if (
          this.netWorkInfo.netMap[d].netMapStartAdd >
          this.netWorkInfo.netMap[d].netMapEndAdd
        ) {
          this.$message.error(this.$t("addressCheck"));
          return;
        }
      }
      // this.netWorkInfo.netMap.forEach((i,d)=>{
      //   i.netMapAcceptanceFilter = this.toDecimal(this.MapAcceptanceArr[d])
      //   if (this.netWorkInfo.netMap[d].netMapStartAdd > this.netWorkInfo.netMap[d].netMapEndAdd) {
      //     this.$message.error(this.$t('addressCheck'))
      //     return
      //   }
      // })
      // this.netWorkInfo.netMapAcceptanceFilter = this.toDecimal(this.receptionArr)
      // if (this.netWorkInfo.netMapStartAdd > this.netWorkInfo.netMapEndAdd) {
      //   this.$message.error(this.$t('addressCheck'))
      //   return
      // }
      setPanelNetworkInfo({
        panelNo: this.panelNo,
        projectId: this.projectId,
        netWorkInfo: JSON.stringify(this.netWorkInfo)
      }).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t("saveSuccess"));
        }
      });
    },
    //十进制转为 二进制
    toBinary(num) {
      if (isNaN(num)) {
        return [];
      } else {
        return num
          .toString(2)
          .split("")
          .reverse();
      }
    },
    // 二进制转为十进制
    toDecimal(info) {
      let arr = [];
      info.forEach(element => {
        arr.push(element.value);
      });
      arr.push("0");
      return parseInt(
        arr
          .reverse()
          .join(",")
          .replace(/,/g, ""),
        2
      );
    },
    getPanelDetail() {
      getPanelDetail({
        panelId: this.panelId,
        projectId: this.projectId
      }).then(res => {
        if (res.code == 1 && res.data.netWorkInfo) {
          this.netWorkInfo = JSON.parse(res.data.netWorkInfo);
          let arr = this.toBinary(this.netWorkInfo.SendFilter);
          arr.forEach((item, index) => {
            this.filterArr[index]["value"] = parseInt(item);
          });
          this.netWorkInfo.netMap.forEach((dd, ii) => {
            let arr2 = this.toBinary(dd.netMapAcceptanceFilter);
            this.$set(this.MapAcceptanceArr, ii, [
              {
                value: 0,
                key: "Alarm"
              },
              {
                value: 0,
                key: "Fault"
              },
              {
                value: 0,
                key: "Disable"
              },
              {
                value: 0,
                key: "Reset"
              },
              {
                value: 0,
                key: "Silence"
              },
              {
                value: 0,
                key: "Time"
              },
              {
                value: 0,
                key: "Delay"
              }
            ]);
            arr2.forEach((item, index) => {
              this.$set(
                this.MapAcceptanceArr[ii][index],
                "value",
                parseInt(item)
              );
            });
          });
        }
      });
    },
    checknum() {
      let i = this.netWorkInfo.netMap.length;
      for (let d = 0; d < i; d++) {
        if (
          this.netWorkInfo.netMap[d].netMapStartAdd >
          this.netWorkInfo.netMap[d].netMapEndAdd
        ) {
          this.$message.error(this.$t("addressCheck"));
          return;
        }
      }
    },
    addNetMap() {
      if (
        this.netWorkInfo.netMap[this.netWorkInfo.netMap.length - 1]
          .netMapStartAdd == null ||
        !this.netWorkInfo.netMap[this.netWorkInfo.netMap.length - 1]
          .netMapEndAdd == null
      ) {
        this.$message.info(this.$t("notDataFill"));
        return;
      }
      this.netWorkInfo.netMap.push({
        netMapStartAdd: null,
        netMapEndAdd: null,
        netMapRegister: 1,
        netMapAcceptanceFilter: 29
      });
      this.MapAcceptanceArr.push([
        {
          value: 0,
          key: "Alarm"
        },
        {
          value: 0,
          key: "Fault"
        },
        {
          value: 0,
          key: "Disable"
        },
        {
          value: 0,
          key: "Reset"
        },
        {
          value: 0,
          key: "Silence"
        },
        {
          value: 0,
          key: "Time"
        },
        {
          value: 0,
          key: "Delay"
        }
      ]);
    },
    delNetMap(index) {
      this.netWorkInfo.netMap.splice(index, 1);
      this.MapAcceptanceArr.splice(index, 1);
    }
  },
  mounted() {
    this.getPanelDetail();
  }
};
</script>

<style lang="less" scope>
.configureNetwork {
  .desc-content {
    width: 1300px;
    display: flex;
    // flex-direction: column;
    .info-item-warp {
      width: 35%;
      display: flex;
      flex-direction: column;
    }
    .info-item-warp-right {
      width: 55%;
      height: 559px;
      margin-left: 80px;
      overflow: auto;
      .info-items {
        position: relative;
        margin-bottom: 20px;
        padding: 10px;

        // border: 1px dashed;
        .del {
          position: absolute;
          top: 27px;
          right: 5px;
          cursor: pointer;
          color: red;
        }
      }
      .add {
        cursor: pointer;
        margin-left: 50%;
      }
      .info-item {
        width: 100%;
        .info-item-content-warp {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .info-item-content {
            width: 33%;
            align-items: center;
          }
        }
        .flag .info-item-content {
          width: 25%;
          .left {
            width: 30%;
          }
          .right {
            width: 70%;
          }
        }
      }
    }
    .info-item {
      margin-top: 10px;
      min-height: 54px;
      padding: 10px 0;
      border-bottom: 1px solid #ccdeee;
      display: inline-block;
      vertical-align: top;
      // width: calc(50% - 50px);
      // width: 450px;
      // border: 1px solid red;
      // &:nth-child(odd) {
      //   margin-right: 50px;
      // }
      // &:nth-child(even) {
      //   margin-left: 50px;
      // }
      .info-item-label {
        font-size: 16px;
        color: #333;
      }
      .info-item-content {
        margin-top: 20px;
        height: 22px;
        display: flex;
        // justify-content: space-between;
        .left {
          width: 45%;
        }
        .right {
          width: 50%;
          i {
            line-height: 32px;
            .f-s-12();
            position: absolute;
            right: 0;
            z-index: 1111;
            cursor: pointer;
          }
          .iconbiyan {
            .f-s-18();
            position: relative;
            top: -1px;
            left: -1px;
          }
        }
      }
    }
  }
}
</style>
